import { workflowAxiosGet } from "../utils/workflowAuthHeaders";

const fetchAgenda = async (appContext, token, username, password) => {
  const { dateGlobal } = appContext;
  const baseUrl = "https://workflow.grupocenze.com.br:38137/rest/";

  try {
    const response = await workflowAxiosGet(
      `${baseUrl}agenda/operador`,
      {
        params: {
          data_inicial: dateGlobal ? dateGlobal : "20230717",
          usuario: "000283",
          empresa: "01",
          filial: "01"
        }
      },
      { token, username, password }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching agenda:", error);
    throw error;
  }
};

export default fetchAgenda;
